<!--
    @name: EdgeProp
    @description：GateProp
    @author: ZengWei
    @date: 2022-08-27 11:26
-->
<template>
  <div>
    <el-form
      ref="form"
      :model="flowBranch"
      label-width="80px"
      label-position="left"
      size="small"
    >
      <el-collapse v-model="activeNames">
        <el-collapse-item name="basic">
          <template #title>
            <span class="collapse-title">基本设置</span>
          </template>
          <el-form-item label="分支名称">
            <el-input v-model="flowBranch.name" @change="onChange" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="优先级">
            <el-radio-group
              v-model="flowBranch.priority"
              style="float: right"
              :disabled="disabled"
              @change="onChange"
            >
              <el-radio-button :label="1">低（P1）</el-radio-button>
              <el-radio-button :label="2">中（P2）</el-radio-button>
              <el-radio-button :label="3">高（P3）</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item name="condition">
          <template #title>
            <span class="collapse-title">条件设置</span>
          </template>
          <div class="form-table">
            <div v-for="(item, index) in flowBranch.condition" :key="index">
              <div class="clearfix self-define" v-if="!disabled">
                <span>{{ index > 9 ? index : "0" + (index + 1) }}</span>
                <span class="float-r" @click="delRule(index)">
                  <i class="el-icon-delete"></i>
                </span>
                <span class="float-r" @click="upGo(index)">
                  <i class="el-icon-top"></i>
                </span>
                <span class="float-r" @click="downGo(index)">
                  <i class="el-icon-bottom"></i>
                </span>
              </div>
              <el-form-item label="逻辑">
                <el-radio-group v-model="item.logicType" @change="onChange" :disabled="disabled">
                  <el-radio :label="1">与 (and)</el-radio>
                  <el-radio :label="2">或 (or)</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="规则类型">
                <el-radio-group
                  class="rule-radio"
                  v-model="item.judgeType"
                  :disabled="disabled"
                  @change="onChange"
                >
                  <el-radio-button :label="1">人员条件</el-radio-button>
                  <el-radio-button :label="2">表单条件</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="人员选择" v-if="item.judgeType === 1">
                <UserPicker
                  :show-choose-button="true"
                  :show-list="item.publisher"
                  @on-select-change="onSelectUser($event,item)">
                </UserPicker>
              </el-form-item>
              <template v-else>
                <el-form-item label="表单控件">
                  <el-select
                    v-model="item.field"
                    placeholder="请选择"
                    :disabled="disabled"
                    @change="onChange"
                  >
                    <el-option
                      v-for="dd in formItem"
                      :key="dd.formId"
                      :label="dd.label"
                      :value="dd.field"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="判断符">
                  <el-select
                    v-model="item.judge"
                    placeholder="请选择"
                    :disabled="disabled"
                    @change="onChange"
                  >
                    <el-option
                      v-for="(dd, ii) in conditionList"
                      :key="ii"
                      :label="dd.name"
                      :value="dd.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="取值">
                  <el-input v-model="item.value" @change="onChange" :disabled="disabled"></el-input>
                </el-form-item>
              </template>
            </div>
            <el-button
              @click="addRule"
              size="small"
              class="add-rule-btn"
              icon="el-icon-plus"
              :disabled="disabled"
              >添加新条件</el-button
            >
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>

<script>
import {Collapse, CollapseItem, RadioButton, RadioGroup, Radio} from "element-ui";
import UserPicker from '@/custom-component/form/formParser/selectUser'

export default {
  name: 'EdgeProp',
  components: {
    UserPicker,
    'el-collapse': Collapse,
    'el-collapse-item': CollapseItem,
    'el-radio-group': RadioGroup,
    'el-radio-button': RadioButton,
    'el-radio': Radio,
  },
  props: {
    curCellProp: {
      type: Object,
      default: () => {},
    },
    formItem: {
      type: Array,
      default: () => [],
    },
    userData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formItemList: [],
      activeNames: 'basic',
      flowBranch: {
        name: '',
        priority: 1,
        condition: [],
      },
      conditionList: [
        { name: '大于', value: 'gt' },
        { name: '小于', value: 'lt' },
        { name: '等于', value: 'eq' },
        { name: '完全等于', value: 'and' },
        { name: '不等于', value: 'neq' },
        { name: '大于等于', value: 'egt' },
        { name: '小于等于', value: 'elt' },
        { name: '包含任意', value: 'in' },
        { name: '不包含', value: 'notin' },
        { name: '介于之间', value: 'between' },
      ],
    };
  },
  mounted() {
    this.initProp();
  },
  methods: {
    onSelectUser(userData,item){
      let users = []
      for (let item of userData) {
        let user = {
          id: item.user_id,
          name: item.name,
          user_table: item.user_table,
          section_id: item.section_id,
          user_id: item.user_id,
        };
        users.push(user);
      }
      item.publisher = users;
      this.onChange();
    },
    initProp() {
      this.flowBranch = this.curCellProp;
    },
    addRule() {
      let item = {
        logicType: 1,
        judgeType: 1,
        userType: 1,
        userArch: 0,
        publisher: [],
        field: '',
        judge: 'gt',
        value: '',
      };
      this.flowBranch.condition.push(item)
      this.onChange();
    },
    delRule(index) {
      this.flowBranch.condition.splice(index,1)
      this.onChange();
    },
    upGo(index) {
      let fieldData = this.flowBranch.condition;
      if(index !== 0){
        fieldData[index] = fieldData.splice(index-1, 1, fieldData[index])[0];
      }else{
        fieldData.push(fieldData.shift());
      }
      this.flowBranch.condition = fieldData;
      this.onChange();
    },
    downGo(index) {
      let fieldData = this.flowBranch.condition;
      if(index !== fieldData.length-1){
        fieldData[index] = fieldData.splice(index+1, 1, fieldData[index])[0];
      }else{
        fieldData.unshift( fieldData.splice(index,1)[0]);
      }
      this.flowBranch.condition = fieldData;
      this.onChange();
    },
    onChange() {
      this.$emit('on-change', this.flowBranch);
    },
  },
};
</script>

<style lang="less" scoped>
.float-r {
  float: right;
  padding: 0 1px;
  cursor: pointer;
}
.self-define {
  margin: 8px 0;
  text-indent: 2px;
}

.collapse-title {
  text-indent: 15px;
}

:deep(.el-collapse-item__content) {
  padding-bottom: 0;
}

:deep(.el-collapse-item__header) {
  position: relative;

  &:before {
    position: absolute;
    top: 16px;
    width: 3px;
    height: 14px;
    margin-right: 10px;
    background-color: var(--themeColor) !important;
    content: "";
  }
}

:deep(.form-table) {
  .el-form-item {
    border: 1px solid #eaebed;
    display: flex;
    margin-bottom: -1px !important;
    /*margin-bottom: -1px !important;*/

    .el-form-item__label {
      border-right: 1px solid #eaebed;
      background: #f8f8f9;
      padding: 6px 10px;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
      padding: 6px 10px;
      overflow: hidden;
      clear: both;
      /*margin-bottom: 1px;*/

      .el-select,
      .el-cascader {
        width: 100%;
      }

      .self-type {
        .el-radio {
          margin-right: 16px;
        }
      }
    }
  }
}

.add-rule-btn {
  margin: 15px 0;
  width: 100%;
}
</style>
